module.exports = __webpack_public_path__ + "img/bwa.d1585fdf.svg";